<template>
  <scroll-right-frame>
    <div class="message-stats-container">
    <!-- 筛选控制区 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-panel">
        <!-- 第一行：筛选条件 -->
        <el-row :gutter="20" class="filter-row">
          <el-col :span="7">
            <div class="filter-item">
              <label class="filter-label">日期范围：</label>
              <el-date-picker
                v-model="filters.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                @change="onDateRangeChange">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-item">
              <label class="filter-label">产品线：</label>
              <el-select
                v-model="filters.productLineIds"
                multiple
                placeholder="请选择产品线"
                clearable
                collapse-tags
                @change="onFilterChange">
                <el-option
                  v-for="item in filterOptions.productLines"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="filter-item">
              <label class="filter-label">消息渠道：</label>
              <el-select
                v-model="filters.channels"
                multiple
                placeholder="请选择渠道"
                clearable
                collapse-tags
                @change="onFilterChange">
                <el-option
                  v-for="item in filterOptions.channels"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-item">
              <label class="filter-label">短信服务商：</label>
              <el-select
                v-model="filters.providers"
                multiple
                placeholder="请选择服务商"
                clearable
                collapse-tags
                @change="onFilterChange">
                <el-option
                  v-for="item in filterOptions.providers"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>

        <!-- 第二行：操作按钮 -->
        <el-row :gutter="20" class="button-row">
          <el-col :span="24" class="filter-buttons">
            <el-button type="primary" icon="el-icon-search" @click="loadChartsData">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetFilters">重置</el-button>
            <el-button
              type="success"
              icon="el-icon-refresh-right"
              :loading="loading"
              @click="refreshData">
              刷新数据
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 统计卡片区 -->
    <el-row :gutter="20" class="stats-cards">
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon total-icon">
              <i class="el-icon-s-data"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ formatNumber(overview.totalTimes) }}</div>
              <div class="stats-label">
                总调用次数
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    所选时间范围和筛选条件下，<br/>
                    所有消息渠道的累计调用次数总和
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon fee-icon">
              <i class="el-icon-coin"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">¥{{ formatMoney(overview.totalFee) }}</div>
              <div class="stats-label">
                总费用
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    所选时间范围和筛选条件下，<br/>
                    所有消息渠道产生的费用总和<br/>
                    <em>注意：部分渠道（如邮件、微信）暂无费用数据</em>
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon avg-icon">
              <i class="el-icon-money"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">¥{{ formatMoney(overview.avgCost) }}</div>
              <div class="stats-label">
                平均单价
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    总费用 ÷ 总调用次数<br/>
                    反映平均每次调用的成本
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stats-card" shadow="hover">
          <div class="stats-item">
            <div class="stats-icon customer-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="stats-content">
              <div class="stats-value">{{ overview.activeCustomers }}</div>
              <div class="stats-label">
                活跃客户数
                <el-tooltip placement="top" effect="light">
                  <div slot="content" style="max-width: 250px;">
                    所选时间范围和筛选条件下，<br/>
                    有使用记录的客户总数
                  </div>
                  <i class="el-icon-question stats-help-icon"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 图表区域 -->
    <el-row :gutter="20" class="charts-row">
      <el-col :span="8">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>渠道使用分布</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                展示各个消息渠道的使用量占比，包括：<br/>
                • 短信 (SMS)<br/>
                • 邮件 (EMAIL)<br/>
                • 微信公众号 (WX_OFFICIAL)<br/>
                • APP推送 (APP/极光推送)<br/>
                • 钉钉机器人 (DINGTALK_ROBOT)<br/>
                • 钉钉工作通知 (DINGTALK_WORK)
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <channel-pie-chart :data="channelStats" :loading="loading" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>短信服务商分布</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                展示短信服务商的使用量分布，包括：<br/>
                • 阿里云短信<br/>
                • 腾讯云短信<br/>
                • 优刻得(UCloud)短信
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <provider-pie-chart :data="providerStats" :loading="loading" />
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>Top10 客户排行</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                按调用次数统计使用量最高的前10个客户，<br/>
                帮助了解主要客户的使用情况。
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <top-customers-chart :data="topCustomers" :loading="loading" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="charts-row">
      <el-col :span="24">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <div class="chart-title-wrapper">
              <span>使用量趋势图</span>
              <el-tooltip placement="top" effect="light">
                <div slot="content" style="max-width: 300px;">
                  <strong>功能说明：</strong><br/>
                  展示所选时间范围内每日的使用量变化趋势，<br/>
                  可切换查看调用次数或费用金额的趋势。<br/>
                  <em>注意：跨年数据会显示完整日期（年-月-日）</em>
                </div>
                <i class="el-icon-question chart-help-icon"></i>
              </el-tooltip>
            </div>
            <div class="chart-tools">
              <el-radio-group v-model="trendType" size="mini" @change="onTrendTypeChange">
                <el-radio-button label="times">调用次数</el-radio-button>
                <el-radio-button label="fee">费用金额</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <trend-line-chart
            :data="dailyTrend"
            :type="trendType"
            :loading="loading" />
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="charts-row">
      <el-col :span="24">
        <el-card class="chart-card" shadow="never">
          <div slot="header" class="chart-header">
            <span>产品线分布</span>
            <el-tooltip placement="top" effect="light">
              <div slot="content" style="max-width: 300px;">
                <strong>功能说明：</strong><br/>
                柱状图展示各产品线的调用次数，<br/>
                折线图展示各产品线的费用金额，<br/>
                帮助了解不同产品线的使用情况和成本分布。
              </div>
              <i class="el-icon-question chart-help-icon"></i>
            </el-tooltip>
          </div>
          <product-line-chart :data="productLineStats" :loading="loading" />
        </el-card>
      </el-col>
    </el-row>

    </div>
  </scroll-right-frame>
</template>

<script>
import util from '../../../../libs/util'
import ScrollRightFrame from '../../../../components/scroll-right-frame.vue'
import ChannelPieChart from './components/channel-pie-chart.vue'
import ProviderPieChart from './components/provider-pie-chart.vue'
import TopCustomersChart from './components/top-customers-chart.vue'
import TrendLineChart from './components/trend-line-chart.vue'
import ProductLineChart from './components/product-line-chart.vue'

export default {
  name: 'MessageStats',
  components: {
    ScrollRightFrame,
    ChannelPieChart,
    ProviderPieChart,
    TopCustomersChart,
    TrendLineChart,
    ProductLineChart
  },
  data() {
    return {
      loading: false,
      trendType: 'times',

      // 筛选条件
      filters: {
        dateRange: [],
        productLineIds: [],
        channels: [],
        providers: []
      },

      // 筛选选项
      filterOptions: {
        productLines: [],
        channels: [],
        providers: []
      },

      // 日期选择器配置
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1) // 设置为本月第一天
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          }
        }]
      },

      // 图表数据
      overview: {
        totalTimes: 0,
        totalFee: 0,
        avgCost: 0,
        activeCustomers: 0
      },
      channelStats: [],
      providerStats: [],
      topCustomers: [],
      dailyTrend: [],
      productLineStats: []
    }
  },

  created() {
    this.initFilters()
    this.loadFilterOptions()
    this.loadChartsData()
  },

  methods: {
    /**
     * 初始化筛选条件
     */
    initFilters() {
      // 默认选中本月
      const end = new Date()
      const start = new Date()
      start.setDate(1) // 设置为本月第一天

      this.filters.dateRange = [
        this.formatDate(start),
        this.formatDate(end)
      ]
    },

    /**
     * 加载筛选选项
     */
    async loadFilterOptions() {
      try {
        const response = await util.ajax.get('/entity/stats/message/filter-options')
        if (response.data.meta.errCode === 0) {
          this.filterOptions = response.data.data
        }
      } catch (error) {
        this.$message.error('加载筛选选项失败: ' + error.message)
      }
    },

    /**
     * 加载图表数据
     */
    async loadChartsData() {
      if (this.loading) return

      this.loading = true
      try {
        const params = {
          startDate: this.filters.dateRange[0],
          endDate: this.filters.dateRange[1],
          productLineIds: this.filters.productLineIds,
          channels: this.filters.channels,
          providers: this.filters.providers
        }

        const response = await util.ajax.post('/entity/stats/message/charts', params)
        if (response.data.meta.errCode === 0) {
          const data = response.data.data
          console.log('=== 接收到的图表数据 ===', data)

          this.overview = data.overview || {}
          this.channelStats = data.channelStats || []
          this.providerStats = data.providerStats || []
          this.topCustomers = data.topCustomers || []
          this.dailyTrend = data.dailyTrend || []
          this.productLineStats = data.productLineStats || []

          console.log('处理后的数据:', {
            overview: this.overview,
            channelStats: this.channelStats,
            providerStats: this.providerStats,
            topCustomers: this.topCustomers,
            dailyTrend: this.dailyTrend,
            productLineStats: this.productLineStats
          })

          // 计算平均单价
          if (this.overview.totalTimes > 0) {
            this.overview.avgCost = this.overview.totalFee / this.overview.totalTimes
          }
        } else {
          this.$message.error('加载数据失败: ' + response.data.meta.errMsg)
        }
      } catch (error) {
        this.$message.error('加载数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },

    /**
     * 刷新数据
     */
    refreshData() {
      this.loadChartsData()
    },

    /**
     * 重置筛选条件
     */
    resetFilters() {
      this.initFilters()
      this.filters.productLineIds = []
      this.filters.channels = []
      this.filters.providers = []
      this.loadChartsData()
    },

    /**
     * 日期范围变化
     */
    onDateRangeChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.loadChartsData()
      }
    },

    /**
     * 筛选条件变化
     */
    onFilterChange() {
      this.loadChartsData()
    },

    /**
     * 趋势图类型变化
     */
    onTrendTypeChange() {
      // 趋势图组件会自动响应type变化
    },

    /**
     * 格式化数字
     */
    formatNumber(num) {
      if (!num) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    /**
     * 格式化金额
     */
    formatMoney(amount) {
      if (!amount) return '0.00'
      return Number(amount).toFixed(2)
    },

    /**
     * 格式化日期
     */
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.message-stats-container {
  padding: 0 10px 0 0; /* 右侧留10px给滚动条 */
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
  max-width: 100%; /* 防止横向滚动 */
  overflow-x: hidden; /* 隐藏横向滚动条 */
  box-sizing: border-box;
}

/* 筛选卡片美化 */
.filter-card {
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.filter-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.12);
}

.filter-card /deep/ .el-card__body {
  padding: 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.filter-panel {
  padding: 0;
}

.filter-row {
  margin-bottom: 0;
}

.button-row {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.filter-item {
  display: flex;
  align-items: center;
  width: 100%;
}

.filter-label {
  flex-shrink: 0;
  width: 90px;
  font-weight: 600;
  color: #303133;
  font-size: 14px;
  text-align: right;
  padding-right: 12px;
}

.filter-item /deep/ .el-date-editor,
.filter-item /deep/ .el-select {
  flex: 1;
}

.filter-buttons {
  text-align: left;
}

.filter-buttons .el-button {
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.filter-buttons .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 统计卡片美化 */
.stats-cards {
  margin-bottom: 24px;
}

.stats-card {
  border-radius: 16px;
  border: none;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  position: relative;
}

.stats-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.stats-card:hover::before {
  opacity: 1;
}

.stats-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.15);
}

.stats-card /deep/ .el-card__body {
  padding: 24px;
  background: white;
}

.stats-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.stats-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  font-size: 28px;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  animation: iconPulse 2s ease-in-out infinite;
}

.stats-card:hover .stats-icon {
  transform: rotate(5deg) scale(1.1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

@keyframes iconPulse {
  0%, 100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  50% {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  }
}

.total-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.fee-icon {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.avg-icon {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

.customer-icon {
  background: linear-gradient(135deg, #5daf7f 0%, #4ab8a8 100%);
}

.stats-content {
  flex: 1;
}

.stats-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
  animation: valueSlideIn 0.6s ease-out;
}

@keyframes valueSlideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.stats-label {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.stats-help-icon {
  font-size: 14px;
  color: #c0c4cc;
  cursor: help;
  transition: all 0.3s ease;
}

.stats-help-icon:hover {
  color: #667eea;
  transform: scale(1.15);
}

/* 图表卡片美化 */
.charts-row {
  margin-bottom: 24px;
}

.chart-card {
  border-radius: 16px;
  border: none;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  background: white;
}

.chart-card:hover {
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.12);
  transform: translateY(-4px);
}

.chart-card /deep/ .el-card__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e4e7ed;
  padding: 20px 24px;
}

.chart-card /deep/ .el-card__body {
  padding: 20px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.chart-header span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-header span::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.chart-title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-help-icon {
  font-size: 16px;
  color: #909399;
  cursor: help;
  transition: all 0.3s ease;
  margin-left: 8px;
}

.chart-help-icon:hover {
  color: #667eea;
  transform: scale(1.2);
}

.chart-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chart-tools /deep/ .el-radio-button__inner {
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.chart-tools /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* 表格卡片美化 */
.table-card {
  margin-bottom: 24px;
  border-radius: 16px;
  border: none;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background: white;
}

.table-card /deep/ .el-card__header {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 2px solid #e4e7ed;
  padding: 20px 24px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.table-header span {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-header span::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.table-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-tools .el-button {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.table-tools .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
}

/* 日期选择器美化 */
.message-stats-container /deep/ .el-date-editor {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.message-stats-container /deep/ .el-date-editor:hover {
  border-color: #667eea;
}

.message-stats-container /deep/ .el-date-editor.is-active {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

/* 下拉选择器美化 */
.message-stats-container /deep/ .el-select {
  width: 100%;
}

.message-stats-container /deep/ .el-input__inner {
  border-radius: 8px;
  transition: all 0.3s ease;
}

.message-stats-container /deep/ .el-input__inner:hover {
  border-color: #667eea;
}

.message-stats-container /deep/ .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

/* 按钮美化 */
.message-stats-container /deep/ .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.message-stats-container /deep/ .el-button--primary:hover {
  background: linear-gradient(135deg, #7e8ff0 0%, #8d5bb2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.message-stats-container /deep/ .el-button--success {
  background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
  border: none;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
}

.message-stats-container /deep/ .el-button--success:hover {
  background: linear-gradient(135deg, #85ce61 0%, #95d475 100%);
  box-shadow: 0 4px 12px rgba(103, 194, 58, 0.4);
}

/* 加载动画 */
.message-stats-container.loading {
  position: relative;
}

.message-stats-container.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 999;
}

/* 防止横向滚动 */
.filter-card,
.stats-card,
.chart-card {
  max-width: 100%;
  box-sizing: border-box;
}

.el-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.el-col {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .stats-cards .el-col {
    margin-bottom: 16px;
  }

  .charts-row .el-col {
    margin-bottom: 24px;
  }

  .stats-value {
    font-size: 24px;
  }

  .stats-icon {
    width: 56px;
    height: 56px;
    font-size: 24px;
  }
}

@media (max-width: 768px) {
  .filter-panel .el-col {
    margin-bottom: 12px;
  }

  .filter-buttons {
    text-align: left;
    padding-top: 10px;
  }

  .chart-card {
    height: 340px;
  }

  .stats-value {
    font-size: 22px;
  }

  .stats-icon {
    width: 48px;
    height: 48px;
    font-size: 20px;
    margin-right: 12px;
  }

  .filter-card /deep/ .el-card__body,
  .chart-card /deep/ .el-card__body,
  .table-card /deep/ .el-card__body {
    padding: 16px;
  }
}

/* 添加进入动画 */
.stats-card {
  animation: cardFadeIn 0.6s ease-out backwards;
}

.stats-card:nth-child(1) { animation-delay: 0.1s; }
.stats-card:nth-child(2) { animation-delay: 0.2s; }
.stats-card:nth-child(3) { animation-delay: 0.3s; }
.stats-card:nth-child(4) { animation-delay: 0.4s; }

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chart-card {
  animation: chartFadeIn 0.8s ease-out backwards;
}

@keyframes chartFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 图表占位符 */
.chart-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #909399;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  min-height: 320px;
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #7e8ff0 0%, #8d5bb2 100%);
}
</style>



// WEBPACK FOOTER //
// src/custom/components/stats/message-stats/message-stats.vue